// Import polyfills
import './polyfill';

// Import vendor javascript
import './vendor';

import { EventManager } from './core/events/manager';

import { Component } from './components/base';

import { UpcomingComponent } from './components/upcoming';
import { CalendarComponent } from './components/calendar';
import { CalendarFiltersComponent } from './components/calendar-filters';
import { NicknameComponent } from './components/nickname';
import { TourComponent } from './components/tour';
import { RichTextComponent } from './components/rich-text';
import { EventComponent } from './components/event';
import { PanelCalendarComponent } from './components/panel-calendar';
import { ReleaseNotesComponent } from './components/release-notes';
import { WebhookFormComponent } from './components/webhook';


export class App {
  private static instance: App|null = null;

  static getApp() {
    if (! this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }

  public loadedComponents: Component[];
  public eventManager: EventManager;

  constructor () {
    this.loadedComponents = [];
    this.eventManager = new EventManager();
  }

  load (componentList: any[]) {
    let components: Component[] = [];
    for (const componentClass of componentList) {
      const component: Component = new componentClass(this);
      component.register();

      if (componentClass.shouldLoad()) {
        components.push(component);
      }
    }

    // Start all components.
    for (const component of components) {
      component.load();
      this.loadedComponents.push(component);
    }
  }
}


// Boot app.
const app = App.getApp();

// Load components.
app.load([
  UpcomingComponent,
  CalendarComponent,
  CalendarFiltersComponent,
  NicknameComponent,
  TourComponent,
  RichTextComponent,
  EventComponent,
  PanelCalendarComponent,
  ReleaseNotesComponent,
  WebhookFormComponent,
]);



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/app.ts